<template>
  <div ref="map"></div>
</template>

<script>
import DiseaseService from "@/services/disease/disease.service";
import CoreKakaoMap from "@/core/core-kakao-map";

export default {
  name: "DiseaseAreaCountMapComponent",
  components: {},
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          cropCode: "0",
          callback: {
            sidoCode: "",
            sggCode: "",
          },
        };
      },
    },
  },
  data() {
    return {
      markerList: null,
      kakaoMap: null,
      map: {
        default: {
          address: "선택된 위치가 없습니다",
          latitude: 37.5653888,
          longitude: 126.9783866,
          level: 12,
        },
      },
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      const defaultLocation = this.map.default;
      const location = {
        address1: defaultLocation.address,
        latitude: defaultLocation.latitude,
        longitude: defaultLocation.longitude,
        level: defaultLocation.level,
      };
      this.initMap(location);
    });
  },
  watch: {
    "properties.cropCode"(val) {
      //console.log("cropCode : ", val);
      this.redrawMarkers(val);
    },
  },
  methods: {
    async redrawMarkers(cropCode) {
      if (this.markerList != null) {
        this.markerList.forEach((marker) => {
          this.kakaoMap.clearMarker(marker);
        });
      }

      const areaList = await DiseaseService.getAreaList(cropCode);
      //console.log("areaList : ", areaList);
      const markerList = [];
      const bounds = new kakao.maps.LatLngBounds();
      areaList.forEach((area) => {
        const text = `${area.sidoName} ${area.sggName} <span style="font-size: 120%; font-weight: bold; color: red">${area.count}</span>건`;
        const properties = this.properties;
        const kakaoMap = this.kakaoMap;
        const marker = kakaoMap.addMarkerAndOverlay(
          area.latitude,
          area.longitude,
          text,
          () => {
            properties.callback = {
              sidoCode: area.sidoCode,
              sggCode: area.sggCode,
              sidoName: area.sidoName,
              sggName: area.sggName,
              cropCode: area.cropCode,
            };

            if (marker.overlay != null) {
              marker.overlay.setMap(null);
            }
            marker.setMap(null);

            marker.setMap(kakaoMap.map);
            marker.overlay.setMap(kakaoMap.map);

            //console.log("click marker : ", properties.callback);
          },
        );
        markerList.push(marker);
        bounds.extend(marker.getPosition());
      });
      this.markerList = markerList;

      if (areaList.length > 0) {
        this.kakaoMap.map.setBounds(bounds, 100, 50, 0, 50);
      } else {
        const defaultMap = this.map.default;
        this.kakaoMap.setCenterAndLevel(
          defaultMap.latitude,
          defaultMap.longitude,
          defaultMap.level,
        );
      }
    },
    initMap(params) {
      //console.log("init map");
      const mapData = this.map;

      const mapElement = this.$refs.map;

      const kakaoMap = (this.kakaoMap = new CoreKakaoMap({
        map: {
          element: mapElement,
          option: {
            center: new kakao.maps.LatLng(params.latitude, params.longitude),
            level: params.level,
          },
        },
        callback: {},
      }));
    },
  },
};
</script>
